// extracted by mini-css-extract-plugin
export default {"SearchFormMobile":"SearchFormMobile_SearchFormMobile__AfMMY"};